import { Form, Modal } from "react-bootstrap";
import React, { useState } from "react";
import Moment from "react-moment";
import { useIntl } from "react-intl";
import {
  IoCloseOutline,
  IoChevronBackOutline,
  IoChevronForwardOutline,
} from "react-icons/io5";
import {
  getAnnouncementTypeCssClasses,
  getDismissedAnnouncementIds,
  dismissAnnouncement,
  undismissAnnouncement,
} from "./announcementHelper";
import cf from "../../../services/codeformatter";

// Shows all unread announcements in a single modal with prev/next pagination.
// The "Don't show this again" checkbox applies to the announcement currently
// shown and is persisted to localStorage immediately on toggle.
export const UnreadAnnouncementsModal = ({ announcements, onClose }) => {
  const intl = useIntl();
  const [index, setIndex] = useState(0);
  const [dismissedIds, setDismissedIds] = useState(() =>
    getDismissedAnnouncementIds()
  );

  const current = announcements[index];
  if (!current) return null;

  const handleDismissToggle = e => {
    if (e.target.checked) {
      dismissAnnouncement(current.id);
    } else {
      undismissAnnouncement(current.id);
    }
    setDismissedIds(getDismissedAnnouncementIds());
  };

  return (
    <Modal show onHide={onClose} centered size="lg">
      <Modal.Header className="py-4 align-items-center">
        <div className="d-flex align-items-center g-2">
          <h6 className="mb-0">
            {intl.formatMessage({ id: "ANNOUNCEMENT" })}
          </h6>
          <div className="ml-3">
            <span className={getAnnouncementTypeCssClasses(current.type)}>
              {cf.format("AnnouncementType", current.type, intl.locale)}
            </span>
          </div>
        </div>
        <button
          className="close"
          style={{ border: "transparent" }}
          onClick={onClose}
        >
          <IoCloseOutline />
        </button>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-3">
        <div className="mb-1">
          <span
            className="fw-bold"
            style={{ fontWeight: 600, fontSize: "1.25rem" }}
          >
            {current.title}
          </span>
        </div>
        <div className="mb-3 text-muted">
          <Moment format="ll">{current.createdOn}</Moment>
        </div>
        <div>
          <span className="word-wrap" style={{ whiteSpace: "pre-wrap" }}>
            {current.message}
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-2">
        <div className="d-flex justify-content-between w-100 align-items-center">
          <Form.Check
            type="checkbox"
            id={`dont-show-again-${current.id}`}
            label={intl.formatMessage({ id: "DONT_SHOW_AGAIN" })}
            checked={dismissedIds.includes(current.id)}
            onChange={handleDismissToggle}
          />
          <div className="d-flex align-items-center">
            {announcements.length > 1 && (
              <>
                <button
                  type="button"
                  className="btn btn-icon btn-light btn-sm"
                  aria-label={intl.formatMessage({ id: "PREVIOUS_PAGE" })}
                  disabled={index === 0}
                  onClick={() => setIndex(index - 1)}
                >
                  <IoChevronBackOutline />
                </button>
                <span className="mx-3 text-nowrap">
                  {index + 1} / {announcements.length}
                </span>
                <button
                  type="button"
                  className="btn btn-icon btn-light btn-sm mr-3"
                  aria-label={intl.formatMessage({ id: "NEXT_PAGE" })}
                  disabled={index === announcements.length - 1}
                  onClick={() => setIndex(index + 1)}
                >
                  <IoChevronForwardOutline />
                </button>
              </>
            )}
            <button
              type="button"
              className="btn btn-primary btn-elevate btn-sm"
              onClick={onClose}
            >
              {intl.formatMessage({ id: "CLOSE" })}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
